/* src/pages/Dashboard/DashboardLayout.js */

import React from "react";
import { Outlet } from "react-router-dom";
import "../../styles/layout.css";
import Sidebar from "../../components/Sidebar";
import { fetchClientFeaturesApi } from "../../lib/api";

export default function DashboardLayout() {
  React.useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "admin") return;
    fetchClientFeaturesApi().catch(() => null);
  }, []);

  return (
    <div className="layout">
      <Sidebar />

      <main className="layout-content">
        <Outlet />
      </main>
    </div>
  );
}
